import { render, staticRenderFns } from "./PatientFiles.vue?vue&type=template&id=169c3ee4&"
import script from "./PatientFiles.vue?vue&type=script&lang=js&"
export * from "./PatientFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports